import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    OLPaper: {
      display: "flex",
      flexWrap: "wrap",
      padding: theme.spacing(12),
      marginTop: theme.spacing(8),
    },
    displayColumn: { flexDirection: "column" },
    button: {
      margin: theme.spacing(12, 0, 16),
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        width: "auto",
      },
    },
    alignRight: {
      marginLeft: "auto",
      display: "block",
    },
    alignSelf: {
      alignSelf: "flex-start",
    },
    error: {
      color: theme.red500,
      display: "block",
      fontSize: 14,
      marginBottom: theme.spacing(8),
      marginTop: theme.spacing(5),
      "& + &": {
        marginTop: 0,
      },
    },
    dragDropText: {
      color: theme.gray400,
      fontSize: 13,
      opacity: "0.8",
    },
    dragDropWrapper: {
      margin: theme.spacing(6),
    },
    fullWidth: {
      margin: 0,
      maxWidth: "100%",
      width: "100%",
    },
    conditionSection: {
      borderBottom: `1px solid ${theme.gray100}`,
      maxWidth: "100%",
      padding: theme.spacing(12, 0, 16, 0),
      position: "relative",
      "&+&::after": {
        content: '""',
        left: 0,
        position: "absolute",
        top: 0,
        width: "100%",
      },
      "&+&::before": {
        background: theme.white50,
        color: theme.gray800,
        content: "'AND'",
        fontSize: 14,
        left: 0,
        marginLeft: theme.spacing(24),
        padding: theme.spacing(0, 7),
        position: "absolute",
        top: 0,
        transform: "translate(0, -50%)",
        zIndex: 1,
      },
    },
    conditionWrapper: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
    },
    TooltipWrapper: {
      display: "flex",
      gap: theme.spacing(12),
      flexWrap: "wrap",
      minWidth: 0,
    },
    addTranslation: {
      color: theme.gray500,
      padding: theme.spacing(6),
    },
    toggle: {
      alignSelf: "flex-start",
      margin: theme.spacing(6),
    },
    clearLink: { alignSelf: "start" },
    disabled: {
      cursor: "not-allowed !important",
      "& input": {
        cursor: "not-allowed !important",
      },
      "& label": {
        cursor: "not-allowed !important",
      },
    },
  }),
);
